import { LIST } from './action-types';
const initialState = {
    list: [],
};

export const notifications = (state = initialState, { type, payload = null }: any): any => {
    switch (type) {
        case LIST:
            return {
                ...state,
                list: payload,
            };
        default:
            return state;
    }
};
